import React from "react";
import { Link } from "react-router-dom";
import {
  FaHeart,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaUser,
  FaBriefcase,
  FaHandsHelping,
  FaInfoCircle,
  FaShieldAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const aboutLinks = [
    { name: "Director's Message", href: "/Director's -message" },
    { name: "Program", href: "/program" },
    { name: "Our People", href: "/our-people" },
    { name: "Board Member", href: "/board-member" },
    { name: "Leadership", href: "/leadership" },
  ];

  const joinLinks = [
    { name: "Volunteer", href: "/volunteer" },
    { name: "Career", href: "/career" },
  ];

  const contactLinks = [{ name: "Contact Us", href: "/contact" }];

  const policyLinks = [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Use", href: "/terms" },
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, name: "Facebook", href: "#" },
    { icon: <FaTwitter />, name: "Twitter", href: "#" },
    { icon: <FaInstagram />, name: "Instagram", href: "#" },
    { icon: <FaYoutube />, name: "YouTube", href: "#" },
    { icon: <FaLinkedinIn />, name: "LinkedIn", href: "#" },
  ];

  const headingClass =
    "text-lg font-bold text-white mb-4 flex items-center gap-2 border-b-2 border-[#1298b5] pb-2";

  const linkClass =
    "text-gray-200 hover:text-[#f97316] hover:underline transition-colors";

  return (
    <footer className="bg-gradient-to-br from-[#052f3a] via-[#073b4c] to-[#021f27] border-t border-[#1298b5] pt-10 pb-6 rounded-t-3xl shadow-inner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-8">
          <div className="space-y-4">
            <Link to="/" className="inline-block transition-transform hover:scale-105">
              <h2 className="text-2xl font-bold text-white">
                Aabharan Foundation
              </h2>
            </Link>

            <div className="space-y-3 text-sm text-gray-200">
              <p className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-[#5ecde0] mt-1 flex-shrink-0 text-base" />
                <span className="leading-tight">
                  Naibazar, Durga Puja Road, Sakaldiha, Chandaui, Uttar Pradesh - 232108
                </span>
              </p>

              <p className="flex items-center gap-3">
                <FaPhone className="text-[#5ecde0] flex-shrink-0" />
                <a href="tel:+918318700018" className="hover:text-[#f97316] hover:underline">
                  +91 8318700018
                </a>
              </p>

              <p className="flex items-center gap-3">
                <FaEnvelope className="text-[#5ecde0] flex-shrink-0" />
                <a
                  href="mailto:directors@aabharan.org"
                  className="hover:text-[#f97316] hover:underline"
                >
                  directors@aabharan.org
                </a>
              </p>
            </div>

            <Link
              to="/login"
              className="inline-flex items-center gap-2 bg-[#1298b5] hover:bg-[#f97316] text-white px-4 py-2 rounded-lg text-sm font-medium shadow-md hover:shadow-lg transition-all"
            >
              <FaUser /> Login
            </Link>
          </div>

          <div>
            <h3 className={headingClass}>
              <FaInfoCircle className="text-[#5ecde0]" /> About Us
            </h3>

            <ul className="space-y-2 text-sm">
              {aboutLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.href} className={linkClass}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className={headingClass}>
              <FaHandsHelping className="text-[#5ecde0]" /> Join Us
            </h3>

            <ul className="space-y-2 text-sm mb-6">
              {joinLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.href} className={linkClass}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className={headingClass}>
              <FaBriefcase className="text-[#5ecde0]" /> Contact
            </h3>

            <ul className="space-y-2 text-sm">
              {contactLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.href} className={linkClass}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className={headingClass}>
              <FaShieldAlt className="text-[#5ecde0]" /> Policies
            </h3>

            <ul className="space-y-2 text-sm mb-6">
              {policyLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.href} className={linkClass}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className={headingClass}>Connect</h3>

            <div className="flex flex-wrap gap-3 mb-5">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 text-white hover:bg-[#f97316] hover:text-white p-3 rounded-full transition-all shadow-sm hover:shadow-md border border-white/20"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            <div className="bg-[#1298b5]/20 border border-[#1298b5]/40 p-4 rounded-xl shadow-lg">
              <p className="text-sm font-medium text-white mb-2">
                Subscribe to our newsletter
              </p>

              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 text-sm border border-white/20 rounded-lg focus:ring-2 focus:ring-[#5ecde0] outline-none bg-white text-gray-800"
                />

                <button className="bg-[#1298b5] text-white hover:bg-[#f97316] px-4 py-2 rounded-lg text-sm font-medium shadow transition">
                  Go
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1298b5]/40 pt-5 mt-4 flex flex-col sm:flex-row justify-between items-center text-sm text-gray-300">
          <p>© {currentYear} Aabharan Foundation. All rights reserved.</p>

          <p className="flex items-center gap-1 mt-2 sm:mt-0">
            Made with <FaHeart className="text-[#f97316]" /> for the community
          </p>
        </div>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 right-6 w-10 h-10 bg-[#1298b5] hover:bg-[#f97316] rounded-full flex items-center justify-center text-white shadow-lg transition hover:scale-110 text-lg"
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;